export const CameraRoll = {
  save: async () => {},
  getPhotos: async () => ({ edges: [] }),
}

export default CameraRoll
